import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import logoImg from '../assets/logo/logo192.png';

const Navigation = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isPoliciesOpen, setIsPoliciesOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const togglePolicies = () => {
    setIsPoliciesOpen(!isPoliciesOpen);
  };

  return (
    <nav className="bg-white shadow-soft sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo */}
          <Link to="/" className="flex-shrink-0 flex items-center">
            <img src={logoImg} alt="Checkstall" className="h-8 md:h-9 object-contain" />
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:block">
            <div className="ml-10 flex items-baseline space-x-8">
              <Link
                to="/about"
                className="text-gray-700 hover:text-primary px-3 py-2 rounded-md text-sm font-medium transition-colors duration-200"
              >
                About Us
              </Link>
              <Link
                to="/people"
                className="text-gray-700 hover:text-primary px-3 py-2 rounded-md text-sm font-medium transition-colors duration-200"
              >
                People Involved
              </Link>
              <Link
                to="/careers"
                className="text-gray-700 hover:text-primary px-3 py-2 rounded-md text-sm font-medium transition-colors duration-200"
              >
                Jobs & Careers
              </Link>
              <Link
                to="/downloads"
                className="text-gray-700 hover:text-primary px-3 py-2 rounded-md text-sm font-medium transition-colors duration-200"
              >
                Downloads
              </Link>
              <Link
                to="/how-to-use"
                className="text-gray-700 hover:text-primary px-3 py-2 rounded-md text-sm font-medium transition-colors duration-200"
              >
                How to Use
              </Link>
              <Link
                to="/reviews"
                className="text-gray-700 hover:text-primary px-3 py-2 rounded-md text-sm font-medium transition-colors duration-200"
              >
                Reviews
              </Link>
              
              {/* Policies Dropdown */}
              <div className="relative">
                <button
                  onClick={togglePolicies}
                  className="text-gray-700 hover:text-primary px-3 py-2 rounded-md text-sm font-medium transition-colors duration-200 flex items-center"
                >
                  Policies
                  <svg className="ml-1 h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                  </svg>
                </button>
                
                {isPoliciesOpen && (
                  <div className="absolute right-0 mt-2 w-48 bg-white rounded-2xl shadow-soft-lg border border-gray-100 py-2 z-50">
                    <Link
                      to="/privacy"
                      className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 hover:text-primary transition-colors duration-200"
                      onClick={() => setIsPoliciesOpen(false)}
                    >
                      Privacy Policy
                    </Link>
                    <Link
                      to="/cookies"
                      className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 hover:text-primary transition-colors duration-200"
                      onClick={() => setIsPoliciesOpen(false)}
                    >
                      Cookie Policy
                    </Link>
                    <Link
                      to="/refund"
                      className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 hover:text-primary transition-colors duration-200"
                      onClick={() => setIsPoliciesOpen(false)}
                    >
                      Refund Policy
                    </Link>
                    <Link
                      to="/terms"
                      className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 hover:text-primary transition-colors duration-200"
                      onClick={() => setIsPoliciesOpen(false)}
                    >
                      Terms of Service
                    </Link>
                    <Link
                      to="/delete-data"
                      className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 hover:text-primary transition-colors duration-200"
                      onClick={() => setIsPoliciesOpen(false)}
                    >
                      Delete Account & Data
                    </Link>
                  </div>
                )}
              </div>

              <Link
                to="/contact"
                className="bg-primary text-white px-4 py-2 rounded-2xl text-sm font-medium hover:bg-primary-600 transition-colors duration-200"
              >
                Contact Us
              </Link>
            </div>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <button
              onClick={toggleMenu}
              className="text-gray-700 hover:text-primary p-2 rounded-md"
            >
              <svg className="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                {isMenuOpen ? (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                ) : (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                )}
              </svg>
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden">
            <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3 bg-white border-t border-gray-100">
              <Link
                to="/about"
                className="text-gray-700 hover:text-primary block px-3 py-2 rounded-md text-base font-medium"
                onClick={() => setIsMenuOpen(false)}
              >
                About Us
              </Link>
              <Link
                to="/people"
                className="text-gray-700 hover:text-primary block px-3 py-2 rounded-md text-base font-medium"
                onClick={() => setIsMenuOpen(false)}
              >
                People Involved
              </Link>
              <Link
                to="/careers"
                className="text-gray-700 hover:text-primary block px-3 py-2 rounded-md text-base font-medium"
                onClick={() => setIsMenuOpen(false)}
              >
                Jobs & Careers
              </Link>
              <Link
                to="/downloads"
                className="text-gray-700 hover:text-primary block px-3 py-2 rounded-md text-base font-medium"
                onClick={() => setIsMenuOpen(false)}
              >
                Downloads
              </Link>
              <Link
              to="/how-to-use"
              className="text-gray-700 hover:text-primary block px-3 py-2 rounded-md text-base font-medium transition-colors duration-200"
              onClick={() => setIsMenuOpen(false)}
            >
              How to Use
            </Link>
            <Link
              to="/reviews"
              className="text-gray-700 hover:text-primary block px-3 py-2 rounded-md text-base font-medium transition-colors duration-200"
              onClick={() => setIsMenuOpen(false)}
            >
              Reviews
            </Link>
              <div className="px-3 py-2">
                <div className="text-gray-700 font-medium text-base mb-2">Policies</div>
                <div className="ml-4 space-y-1">
                  <Link
                    to="/privacy"
                    className="text-gray-600 hover:text-primary block py-1 text-sm"
                    onClick={() => setIsMenuOpen(false)}
                  >
                    Privacy Policy
                  </Link>
                  <Link
                    to="/cookies"
                    className="text-gray-600 hover:text-primary block py-1 text-sm"
                    onClick={() => setIsMenuOpen(false)}
                  >
                    Cookie Policy
                  </Link>
                  <Link
                    to="/refund"
                    className="text-gray-600 hover:text-primary block py-1 text-sm"
                    onClick={() => setIsMenuOpen(false)}
                  >
                    Refund Policy
                  </Link>
                  <Link
                    to="/terms"
                    className="text-gray-600 hover:text-primary block py-1 text-sm"
                    onClick={() => setIsMenuOpen(false)}
                  >
                    Terms of Service
                  </Link>
                  <Link
                    to="/delete-data"
                    className="text-gray-600 hover:text-primary block py-1 text-sm"
                    onClick={() => setIsMenuOpen(false)}
                  >
                    Delete Account & Data
                  </Link>
                </div>
              </div>
              <Link
                to="/contact"
                className="bg-primary text-white block px-3 py-2 rounded-2xl text-base font-medium text-center"
                onClick={() => setIsMenuOpen(false)}
              >
                Contact Us
              </Link>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navigation;
